module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am397-0af89eeec44946e35d01d014761deae5.jpg";